export interface BankOption {
  value: string;
  label: string;
}

export const BANK_OPTIONS: BankOption[] = [
  { value: 'BCA', label: 'BCA' },
  { value: 'Mandiri', label: 'Mandiri' },
  { value: 'BNI', label: 'BNI' },
  { value: 'BRI', label: 'BRI' },
  { value: 'CIMB Niaga', label: 'CIMB Niaga' },
  { value: 'Danamon', label: 'Danamon' },
  { value: 'Permata', label: 'Permata' },
  { value: 'BTN', label: 'BTN' },
  { value: 'OCBC NISP', label: 'OCBC NISP' },
  { value: 'Lainnya', label: 'Lainnya' },
];
